import { Controller } from "@hotwired/stimulus"

// The profile link sits in the first cell. A click on any other cell
// follows that same link. A click on the link itself is left alone.
export default class extends Controller {
  open(event) {
    if (event.target.closest("a, button, input, label")) return

    const link = this.element.querySelector("a.stretched-link")
    if (!link) return

    link.click()
  }
}
